<template>
  <el-container style="height: 700px; background-color: white; color: black; text-align: center;">
    <el-main style="display: flex; flex-direction: column; justify-content: center; align-items: center; font-size: 48px; line-height: 1.5;">
      <div>欢迎使用大锤工具箱</div>
      <div style="margin-top: 10px;">网页版将在2026年11月1日正式下线</div>
      <div>后续请切换客户端程序使用</div>
      <div>点击
        <a href="https://api.dcgjx.cn/downloads/dcgjx-v1.0.6.exe" download>
        这里
        </a>
        下载桌面程序
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: "Index",
};
</script>

<style scoped>
body {
  margin: 0;
  font-family: Arial, sans-serif;
  background-color: white;
}
</style>
